// Letter templates of the core mail app in the client's store: the step of a scenario keeps the code, people see the name.

import { useMemo } from 'react';
import type { Id } from '@confdeck/core-shared';
import { useMeta, useSync, useTypesTick } from '../sync/react.tsx';

/** The type of the letter templates of the core mail app. */
export function mailTemplateType(meta: { types(): { id: Id; app: string | null; key: string }[] }): Id | undefined {
  return meta.types().find((t) => t.app === 'mail' && t.key === 'email_template')?.id;
}

/** Templates by code: the name of the template and the code the command sends. */
export function useMailTemplates(): Map<string, string> {
  const meta = useMeta();
  const client = useSync();
  const typeId = mailTemplateType(meta);
  const tick = useTypesTick(typeId ? [typeId] : []);
  return useMemo(() => {
    const out = new Map<string, string>();
    if (!typeId) return out;
    for (const id of client.store.recordIds(typeId)) {
      const r = client.store.record(id);
      const key = String(r?.data.key ?? '').trim();
      if (key) out.set(key, String(r?.data.name ?? key));
    }
    return out;
  }, [typeId, client.store, tick]);
}
